<template>
  <div>
    <label class="main-label mb-3"
      >{{ textFloat }} <span v-if="isRequired" class="text-danger">*</span>
    </label>
    <div :class="['panel-upload', { error: isValidate }]">
      <draggable
        :list="imageList"
        class="d-flex flex-wrap px-md-10 upload-mobile5 w-100"
        @update="update"
      >
        <div
          class="panel-wrap-bg-file-img d-flex w-20"
          v-for="(item, index) in imageList"
          :key="index"
        >
          <div
            class="panel-bg-file-img mb-2"
            v-bind:style="{ backgroundImage: 'url(' + item.image_url + ')' }"
          >
            <font-awesome-icon
              icon="times-circle"
              color="#979797"
              class="icon-delete pointer"
              @click="deleteImage(index, item.id)"
            />
          </div>
        </div>

        <div class="panel-upload-box upload-mobile">
          <div class="panel-bg-file-img mb-2" for="file_upload">
            <font-awesome-icon icon="plus" color="#FFB300" class="icon-add" />
            <input
              type="file"
              name="name"
              ref="input"
              accept="image/png, image/jpeg"
              id="file_upload"
              v-on:change="onFileChange"
            />
          </div>
        </div>
      </draggable>
    </div>
    <div v-if="v && v.$error" class="mt-1">
      <span class="text-error" v-if="v.required == false"
        >Please Upload Image.</span
      >
    </div>
    <ModalAlertError ref="modalAlertError" :text="modalMessage" />
    <ModalLoading ref="modalLoading" :hasClose="false" />
  </div>
</template>

<script>
import ModalAlertError from "@/components/modal/ModalAlertError";
import ModalLoading from "@/components/modal/ModalLoading";
import draggable from "vuedraggable";
import Vue from "vue";

export default {
  components: {
    ModalAlertError,
    ModalLoading,
    draggable,
  },
  props: {
    dataList: {
      required: false,
      type: Array,
    },
    v: {
      required: false,
      type: Object,
    },
    sortingDrag: {
      required: false,
      type: Boolean,
    },
    accept: {
      required: false,
      type: String,
    },
    textFloat: {
      required: false,
      type: String,
    },
    isRequired: {
      required: false,
      type: Boolean,
    },
    isValidate: {
      required: false,
      type: Boolean,
    },
  },
  data() {
    return {
      file: "",
      value: "",
      type: {
        all: ["image/jpeg", "image/png", "application/pdf", ""],
        file: ["image/jpeg", "image/png", "application/pdf"],
        image: ["image/jpeg", "image/png"],
      },
      modalMessage: "",
      image: "",
      filename: "",
      images: "",

      dragging: false,
      // image: this.dataFile && this.dataFile.id ? this.dataFile.imgUrl : require("@/assets/images/icons/picture.png")
    };
  },
  created() {},
  computed: {
    imageList() {
      return this.dataList;
    },
    draggingInfo() {
      return this.dragging ? "under drag" : "";
    },
  },
  methods: {
    onFileChange(e) {
      // this.errorFile = "";
      const file = e.target.files[0];
      this.filename = file.name;
      var _validFileExtensions = this.type[this.accept];

      if (e.target.files.length) {
        if (_validFileExtensions.indexOf(file.type) < 0) {
          this.$refs.input.value = "";
          this.modalMessage = `fileNotSupport`;
          this.$refs.modalAlertError.show();
        } else if (file.size > 10000000) {
          this.modalMessage = `fileIsTooLarge`;
          this.$refs.modalAlertError.show();
        } else {
          // this.image = URL.createObjectURL(file);
          this.handleChangeFileImage(file);
        }
      } else {
        this.$refs.input.value = "";
      }
    },
    handleChangeFileImage: async function (value) {
      if (value) {
        this.$refs.modalLoading.show();
        var reader = new FileReader();
        reader.readAsDataURL(value);
        reader.onload = async () => {
          let im = new Image();
          im.src = reader.result;
          im.onload = async () => {
            if (im.width !== im.height) {
              this.$swal("Please upload image with ratio 1:1 !", {
                icon: "info",
              });
            } else {
              var savetoDB = await this.saveImagetoDb(reader.result);
              await this.saveImage(savetoDB);
            }
            this.$refs.modalLoading.hide();
          };
        };
      } else {
        this.value = "";
      }
    },
    saveImage: async function (value) {
      if (value) {
        this.imageList.push({
          image_url: value,
          id: 0,
          sort_order: 0,
        });
      }
    },
    saveImagetoDb: async function (img) {
      var form = {
        Base64String: img,
      };
      await this.$store.dispatch("ActionUploadImage", form);
      var data = await this.$store.state.moduleConnectAPI.stateUploadImage;
      return data.detail;
    },
    deleteImage(index, id) {
      Vue.nextTick(() => {
        this.$emit("deleteImagesList", id);
      });
      this.imageList.splice(index, 1);
    },
    async update(evt) {
      if (this.sortingDrag) {
        this.$emit("sortOrderImage");
      }
    },
  },
};
</script>

<style scoped>
.panel-upload {
  position: relative;
  /* margin-bottom: 15px; */
  flex-wrap: wrap;
  display: flex;
  border: 1px solid #bfbfbf;
  padding-top: 15px;
  min-height: calc((100vw - 256px - 4rem - 30px) / 7);
}
.panel-upload.error {
  border-color: red !important;
}

.panel-upload-box {
  max-width: 20%;
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
  width: 100%;
}

.panel-upload-box-list {
  max-width: 20%;
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
}

.panel-wrap-bg-file-img {
  padding-right: 15px;
  padding-left: 15px;
  padding-bottom: 15px;
}

.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  padding-bottom: 94.2%;
  border: 2px dashed #979797;
  width: 100%;
  cursor: move;
}

input[type=file], /* FF, IE7+, chrome (except button) */
input[type=file]::-webkit-file-upload-button {
  /* chromes and blink button */
  cursor: pointer;
  width: 100%;
  height: 100%;
  line-height: 95px;
  position: absolute;
  opacity: 0;
}

.icon-add {
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  width: 25px;
  height: 25px;
}

.icon-delete {
  position: absolute;
  right: 1px;
  top: 1px;
  color: #707070;
}
.w-20 {
  width: 20% !important;
}

@media (max-width: 767.98px) {
  .panel-wrap-bg-file-img {
    padding-right: 5px;
    padding-left: 5px;
  }

  .upload-mobile {
    max-width: 100% !important;
    width: 100% !important;
  }
}
</style>
